<div *ngIf="!hasFilters && elfaFilterType !== 'search'" class="filter-list-holding">
  <span>Waiting for all products to load ...</span>
</div>
<div *ngIf="hasFilters" class="flex-100 flex-md-auto filter-sort">
  <button mat-button color="primary" (click)="showFilters('filter')" [class]="!filtersClosed && filterType === 'filter'? 'filter-button filter-button-active': 'filter-button'">
    <span class="filter-title">Filter
      <span *ngIf="noFilters" class="number-of-filters">{{noFilters}}</span>
    </span>
  </button>
  <button mat-button color="primary" (click)="showFilters('sort')" [class]="!filtersClosed && filterType === 'sort'? 'sort-button sort-button-active': 'sort-button'">
    <span class="filter-title">Sort</span>
  </button>
  <div [class]="filtering? 'filter-list-info filter-list-info-show':'filter-list-info'">
    <span *ngIf="noFiltered > 0">Showing {{noFiltered | number:'':'en-AU' }} Product(s)</span>
    <span *ngIf="noFiltered == 0">Displaying Filtered Product</span>
  </div>
</div>

<div [class]="elfaFilterType !== 'search'? 'filter-abs' : 'filter-abs filter-abs-search'">
  <div *ngIf="hasFilters" [class]="filtersClosed? 'flex-100 flex-fill filter-container-closed':'flex-100 flex-fill filter-container'">
    <div class="filters">
      <div class="d-flex flex-row flex-wrap justify-content-center align-items-start">
        <div class="flex-100 flex-fill" *ngIf="filterType === 'sort'">
          <div class="d-flex flex-row flex-wrap justify-content-center align-items-start">
            <div class="flex-100">
              <div class="d-flex flex-row flex-wrap justify-content-center align-items-start filter-list">
                <span class="filter-list-title">Sort By
                </span>
                <mat-radio-group aria-label="Sort By" class="d-flex flex-column text-left">
                  <mat-radio-button *ngFor="let option of sortOptions" [value]="option" [checked]="selectedSort?.id === option?.id" color="warn" (change)="changeSort(option)">{{option.name}}</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-100 flex-fill d-flex flex-row flex-wrap" *ngIf="filterType === 'filter'">
          <div *ngFor="let group of filterGroups" class="w-100">
            <div class="d-flex flex-row flex-wrap justify-content-center align-items-start filter-list mat-tab-no-border">
              <span class="filter-list-title">
                <span class="filter-list-remove-all">
                  <button *ngIf="filterAny(group)" mat-raised-button color="warn" (click)="filterRemoveAll()">
                    Clear Filters
                  </button>
                </span>
              </span>
              <div *ngIf="!filtersAvailable()"><span class="filters-none">No Product Filters Available</span></div>
              <mat-tab-group *ngIf="filtersAvailable()" mat-tabs mat-align-tabs="center" mat-stretch-tabs="false" color="primary" [(selectedIndex)]="filterTab" class="w-100">
                <div *ngFor="let filter of group.filters">
                  <mat-tab *ngIf="filter.options?.length > 1" [label]="filterName(filter)">
                    <div class="d-flex flex-row flex-wrap justify-content-around align-items-center" [class]="filter.name.toLowerCase() + ' mb-1 mt-1'" *ngIf="filter.name.toLowerCase() === 'brand'">
                      <div class="flex-auto mt-1" *ngFor="let option of filter.options">
                        <button *ngIf="!option.imageUrl" mat-raised-button class="category-button" [color]="option.checked? 'warn': 'primary'" (click)="filterUpdateOption(option)">
                          <span [innerHtml]="option.name | safeHtml"></span>
                        </button>
                        <button *ngIf="option.imageUrl" class="brand-filter" (click)="filterUpdateOption(option)">
                          <picture>
                            <source [srcset]="option.imageUrl + '.webp'" type="image/webp" />
                            <img [src]="option.imageUrl" [alt]="option.name" [class]="option.checked?'active': 'inactive'">
                          </picture>
                          <span [innerHtml]="option.name | safeHtml"></span>
                        </button>
                      </div>
                    </div>
                    <ul [class]="filter.name.toLowerCase()" *ngIf="filter.name.toLowerCase() !== 'brand'" class="d-flex flex-row flex-wrap">
                      <li class="flex-50 flex-md-33" *ngFor="let option of filter.options" [hidden]="filter.name.toLowerCase() === 'series' && option.disabled">
                        <mat-checkbox [checked]="option.checked" color="warn" (change)="filterUpdateOption(option)">
                          <span class="filter-span" [innerHtml]="option.name | safeHtml"></span>
                        </mat-checkbox>
                      </li>
                    </ul>
                  </mat-tab>
                </div>
              </mat-tab-group>
            </div>
          </div>
        </div>
        <div class="filter-footer">
          <button mat-button color="accent" (click)="filtersClosed = true">
            <div class="d-flex flex-row">
              <mat-icon color="accent" class="flex-auto footer-button">arrow_drop_up</mat-icon>
              <span class="flex-auto close-filters">Close Filters</span>
              <mat-icon color="accent" class="flex-auto footer-button">arrow_drop_up</mat-icon>
              </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
